module.exports = __webpack_public_path__ + "img/lokalt.eaf8e868.png";